import React from "react";
import { Database, Users, Rss, FileText, BarChart3, Briefcase, MessageSquare } from "lucide-react";
import { Solution } from "./types";

export const SOLUTIONS: Solution[] = [
  {
    id: "erp",
    title: "ERP Systems",
    description: "Inventory, accounting, and operations suite for D2C brands and retail chains.",
    icon: <Database className="w-6 h-6" />,
    gradient: "from-orange-500/20 to-transparent",
    features: ["D2C Inventory Sync", "Multi-store POS", "GST Accounting", "Cloud Kitchen Billing"],
    longDesc: "Our custom ERP provides a cohesive ecosystem for managing your business-critical processes. Designed for scalability, it allows you to monitor resource allocation, automate financial documentation, and manage human capital from a single, integrated dashboard.",
    useCase: "Ideal for manufacturing, retail, and large-scale service providers looking for a custom-branded operational backbone."
  },
  {
    id: "crm",
    title: "CRM Solutions",
    description: "Forge stronger relationships with a white-labeled customer management platform.",
    icon: <Users className="w-6 h-6" />,
    gradient: "from-blue-500/20 to-transparent",
    features: ["Lead Scoring", "Automated Workflows", "Customer History", "Sales Pipeline"],
    longDesc: "Deepen customer loyalty with a data-driven CRM tailored for your business. The platform offers real-time visualization of your sales funnel, integration with marketing tools, and granular customer behavior analytics, all under your professional brand.",
    useCase: "Perfect for sales-heavy organizations and growth-focused businesses providing high-touch customer management."
  },
  {
    id: "rss",
    title: "RSS & Content",
    description: "Dynamic content aggregation and distribution for your niche audience.",
    icon: <Rss className="w-6 h-6" />,
    gradient: "from-purple-500/20 to-transparent",
    features: ["Auto-Aggregation", "Smart Filtering", "Custom Feeds", "Push Notifications"],
    longDesc: "Deliver targeted information with our heavy-duty RSS engine. Aggregate content from thousands of sources, filter by relevance, and distribute through your own branded news portal or internal knowledge base.",
    useCase: "Great for industry-specific news hubs, research firms, and internal content curators."
  },
  {
    id: "file-management",
    title: "File Management",
    description: "Secure, collaborative storage and sharing under your own enterprise brand.",
    icon: <FileText className="w-6 h-6" />,
    gradient: "from-green-500/20 to-transparent",
    features: ["Version Control", "External Sharing", "E2E Encryption", "Search Indexing"],
    longDesc: "Replace generic storage with a professional, secure file management system. Own your cloud environment with collaborative editing and sophisticated permission controls designed for your team's workflow.",
    useCase: "Essential for legal firms, creative agencies, and security-conscious consultancies."
  },
  {
    id: "analytics",
    title: "Advanced Analytics",
    description: "Turn data into decisions with custom-branded visual insights and reporting.",
    icon: <BarChart3 className="w-6 h-6" />,
    gradient: "from-red-500/20 to-transparent",
    features: ["Real-time Dashboards", "Predictive Modeling", "Custom Reports", "Data Connectors"],
    longDesc: "Provide high-end visual intelligence across your organization. Our analytics engine ingests raw data and outputs stunning, actionable reports that allow you to see the story behind your business numbers.",
    useCase: "Designed for data analysts, performance marketers, and financial advisors."
  },
  {
    id: "project-management",
    title: "Project Management",
    description: "Specialized ERP and LMS for schools, colleges, and healthcare chains.",
    icon: <Briefcase className="w-6 h-6" />,
    gradient: "from-yellow-500/20 to-transparent",
    features: ["School LMS", "Real Estate CRM", "Patient Management", "Construction Sprints"],
    longDesc: "Advanced management tools for your specific vertical. From integrated LMS for Bangalore's top education institutes to project tracking for high-margin construction and real estate firms, our platform adapts to your organization's specific workflows.",
    useCase: "Suited for dental clinics, coaching centers, and construction companies requiring granular operational control."
  },
  {
    id: "support",
    title: "Customer Support",
    description: "Omnichannel ticketing and support desk tailored to your workflow.",
    icon: <MessageSquare className="w-6 h-6" />,
    gradient: "from-cyan-500/20 to-transparent",
    features: ["Ticket Automation", "Knowledge Base", "Live Chat Sync", "SLA Monitoring"],
    longDesc: "Elevate your customer experience with a robust support portal. Handle high volume inquiries with ease using automated routing, internal collaboration tools, and comprehensive performance metrics tailored to your support team.",
    useCase: "Critical for SaaS companies, e-commerce stores, and technical support teams."
  },
];
